'use client';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useSearchParams } from 'next/navigation';
import { PropsWithChildren, useEffect, useRef } from 'react';

type Props = PropsWithChildren;

export default function CatalogsScrollArea({ children }: Props) {
  const listRef = useRef<HTMLDivElement | null>(null);
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  const searchParams = useSearchParams();

  useEffect(() => {
    // TODO - ignore google analytics params, refactor when that is fixed
    const paramsArr = [...searchParams.keys()].filter(
      (k) => k !== '_gl' && k !== '_ga',
    );
    if (paramsArr.length > 0) {
      // account for fixed header (124 + some margin) on desktop
      // 188 on mobile to account for "find your villa" sticky button
      const scrollOffset = isDesktop ? 128 : 188;
      setTimeout(() => {
        const topOffset = listRef.current!.offsetTop - scrollOffset;
        window.scrollTo({ top: topOffset, behavior: 'instant' });
      }, 100);
    }
  }, [isDesktop, listRef, searchParams]);

  return (
    <div ref={listRef} className="pb-4 flex flex-wrap">
      <div className="block whitespace-nowrap overflow-x-scroll xl:overflow-x-hidden xl:whitespace-normal">
        {children}
      </div>
    </div>
  );
}
